module.exports = __webpack_public_path__ + "static/media/Metropolis-Medium.dc29bcfe.woff";